import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const GlobeGl = ({ 
  gData, 
  setSelectedCountry, 
  optionAutoRotate = true, 
  optionEnableZoom = false, 
  optionAutoRotateSpeed = -2.5,
  hasPlayPause = true,
}) => {

  const globeWrapRef = useRef();
  const globeRef = useRef();

  const [width, setWidth] = useState(0);
  useEffect(() => {
    const theGlobe = theGlobeRef.current;
    if ( ! theGlobe ) return;
    theGlobe.width(width)
  }, [width]);

  const [height, setHeight] = useState(0);
  useEffect(() => {
    const theGlobe = theGlobeRef.current;
    if ( ! theGlobe ) return;
    theGlobe.height(height)
  }, [height]);

  const [pointOfView, setPointOfView] = useState(undefined);

  function sizeGlobe() {
    const globe = globeWrapRef.current;
    setWidth(globe.offsetWidth);
    setHeight(globe.offsetHeight);
  }

  useEffect(() => {
    sizeGlobe();
    window.addEventListener('resize', sizeGlobe);
    return () => window.removeEventListener('resize', sizeGlobe);
  }, []);


  const [autoRotate, setAutoRotate] = useState(optionAutoRotate);
  useEffect(() => {
    const theGlobe = theGlobeRef.current;
    if ( ! theGlobe ) return;
    theGlobe.controls().autoRotate = autoRotate;
  }, [autoRotate]);

  const [autoRotateSpeed, setAutoRotateSpeed] = useState(optionAutoRotateSpeed);
  useEffect(() => {
    const theGlobe = theGlobeRef.current;
    if ( ! theGlobe ) return;
    theGlobe.theGlobe.controls().autoRotateSpeed = autoRotateSpeed;
  }, [autoRotateSpeed]);

  const [enableZoom, setEnableZoom] = useState(optionEnableZoom);
  useEffect(() => {
    const theGlobe = theGlobeRef.current;
    if ( ! theGlobe ) return;
    theGlobe.theGlobe.controls().enableZoom = enableZoom;
  }, [enableZoom]);

  const [isInView, setIsInView] = useState(false);
  useEffect(() => {
    const theGlobe = theGlobeRef.current;
    if ( ! theGlobe ) return;
    if ( ! isInView ) {
      theGlobe.pauseAnimation();
    }
    else {
      theGlobe.resumeAnimation();
    }
  }, [isInView]);
  

  const loaderRef = useRef();

  useEffect(() => {
    const loaderRef = globeWrapRef.current;
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0,0.05,0.1,0.5,1]
    };
    observer = new IntersectionObserver(( entries ) => {
      if ( entries[0].intersectionRatio > 0 ) {
        setIsInView(true);
      }
      else {
        setIsInView(false);
      }
    }, options);
    observer.observe( loaderRef );
    return () => observer.disconnect();
  }, []);

  const [hasBeenVisible, setHasBeenVisible] = useState(false);
  useEffect(() => {
    const loaderRef = globeWrapRef.current;
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0,0.1,0.2,0.3,0.4,0.5,1]
    };
    observer = new IntersectionObserver(( entries ) => {
      if ( entries[0].intersectionRatio > 0 ) {
        setHasBeenVisible(true);
        observer.disconnect();
      }
    }, options);
    observer.observe( loaderRef );
    return () => observer.disconnect();
  }, []);
  
  const ringsData = [];
  const pointsData = [];

  gData.forEach((point, i) => {
    
    /*pointsData.push({
      id: point.id,
      lat: point.lat,
      lng: point.lng,
      size: 0.01, 
      color: "transparent",
      radius: 2,
      label: point.label,
    });*/
    pointsData.push({
      id: point.id,
      lat: point.lat,
      lng: point.lng,
      size: 0.01, 
      color: "#cccccc",
      radius: 1,
      label: point.label,
    });
    /*
    ringsData.push({
      id: point.id,
      lat: point.lat,
      lng: point.lng,
      maxR: 9,
      propagationSpeed: 6,
      repeatPeriod: 1600
    });*/

  });

  const [isGlobeInitialized, setIsGlobeInitialized] = useState(false);
  const [countries, setCountries] = useState({ features: []});

  useEffect(() => {
    // FIX: potentially use smaller dataset? this thing is huge
    fetch('/data/ne_110m_land.geojson').then(res => res.json()).then(setCountries);
  }, []);
  
  const theGlobeRef = useRef();
  let Globe = () => null;

  function initializeGlobe(theGlobeRef) {
    const theGlobe = theGlobeRef.current;
    if ( ! theGlobe ) return;
    const globeElement = globeRef.current;
    //console.log("initialize globe function")
    theGlobe(globeElement)
      .atmosphereAltitude(0.1)
      .atmosphereColor("#999")
      .backgroundColor("rgba(0,0,0,0)")
      .width(width)
      .height(height)

      //.showGraticules(false)

      .pointsData(pointsData)
      .pointAltitude("size")
      .pointColor("color")
      .pointRadius("radius")
      .pointLabel("label")
      .pointResolution(20)
      .onPointHover(point => {
        setAutoRotate( ! point );
        //theGlobe.controls().autoRotate = ! point;
        //setSelectedCountry(point);
      })
      /*
      .ringsData(ringsData)
      .ringColor(() => t => `rgba(255,255,255,${1-t})`)
      .ringMaxRadius("maxR")
      .ringPropagationSpeed("propagationSpeed")
      .ringRepeatPeriod("repeatPeriod")
      */
      .hexPolygonsData(countries.features)
      .hexPolygonResolution(2)
      .hexPolygonMargin(0.75)
      .hexPolygonColor(() => `#888888`)
      //.onHexPolygonClick(() => globeRef.current.controls().autoRotate = ! globeRef.current.controls().autoRotate )
      
      theGlobe.controls().autoRotate = autoRotate;
      theGlobe.controls().enableZoom = enableZoom;
      setIsGlobeInitialized(true);
  }
  function destroyGlobe(theGlobeRef) {
    const theGlobe = theGlobeRef.current;
    if ( ! theGlobe ) return;
    theGlobe._destructor();
    setIsGlobeInitialized(false);
  }

  useEffect(() => {
    if ( countries.features.length === 0 ) return;

    if ( isGlobeInitialized ) return;

    if ( typeof window !== "undefined" ) {
      Globe = require("globe.gl").default;
    }

    //console.log("initialize globe")
    theGlobeRef.current = Globe();

    if ( ! hasBeenVisible ) return;

    initializeGlobe(theGlobeRef);

    return () => destroyGlobe(theGlobeRef);

  },[countries, hasBeenVisible])

  return (
    <StyledGlobeWrap ref={globeWrapRef}>
      <div>
        <div id="container" ref={globeRef}></div>
      </div>
      {hasPlayPause && (
        <button 
          type="button" 
          onClick={() => setAutoRotate( ! autoRotate ) } 
          title={autoRotate ? "Pause Globe" : "Spin Globe"} 
          className={autoRotate ? "is-playing" : undefined }
        ></button>
      )}
      <span ref={loaderRef} />
    </StyledGlobeWrap>
  );
};

export default GlobeGl;

const StyledGlobeWrap = styled.div`
  position: relative;
  z-index: 0;
  > div {
    position: relative;
    padding-bottom: 100%;
    height: 0;
    > div {
      position: relative;
      width: 100%;
      max-width: 100%;
    }
  }
  > button {
    position: absolute;
    bottom: 15%;
    right: 15%;
    @media ( min-width: 48em ) {
      bottom: 20%;
      right: 20%;
    }
    z-index: 10;
    display: block;
    height: 2em;
    width: 2em;
    z-index: 2;
    display: grid;
    grid-template: 1fr / 1fr;
    place-items: center;
    border: 1px solid;
    border-radius: 50%;
    opacity: 0.2;
    transition: opacity 0.2s ease;
    .can-hover &:hover,
    &:active {
      opacity: 0.6;
    }
    cursor: pointer;
    &::before {
      content: '';
      position: relative;
      z-index: 3;
      display: block;
      height: calc(1.5em * 0.5);
      width: calc(1.25em * 0.5);
      background-color: currentColor;
      clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
      margin-left: 0.125em;
    }
    &.is-playing::before {
      clip-path: polygon(0 0, 40% 0, 40% 100%, 60% 100%, 60% 0, 100% 0, 100% 100%, 0 100%);
      margin-left: 0;
    }
  }
  .scene-tooltip {
    background-color: rgba(255,255,255,0.9);
    padding: 0.6em 0.75em 0.5em 0.875em;
    font-family: inherit;
    font-size: 0.875em;
    line-height: 1;
    font-family: var(--font-heading);
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0.05em;
    box-shadow: 0 0.125em 0.25em rgba(0,0,0,0.5);
    color: var(--theme-text-against-light);
    border-radius: 2em;
    &:empty {
      display: none;
    }
  }
  > span {
    position: absolute;
    top: 50%;
    margin-top: -100vh;
    left: 50%;
    height: 200vh;
    width: 1px;
    z-index: -1;
  }
`;

